import type { ComponentProps } from 'react';

export interface LinkProps extends Omit<ComponentProps<'a'>, 'href'> {
  href: string;
  /** Override auto-detection. Defaults to true when href starts with http:// or https://. */
  external?: boolean;
}

const EXTERNAL_REGEX = /^https?:\/\//;

export function Link({ href, external, target, rel, ...rest }: LinkProps) {
  const isExternal = external ?? EXTERNAL_REGEX.test(href);
  return (
    <a
      href={href}
      target={target ?? (isExternal ? '_blank' : undefined)}
      rel={rel ?? (isExternal ? 'noopener noreferrer' : undefined)}
      {...rest}
    />
  );
}
